package com.milta.feature.route.domain.entity

enum class RouteStatus {
    Scheduled,
    InProgress,
    Completed,
}
